import { HttpHeaders } from '@angular/common/http';

export class HeaderForAuthentication extends HttpHeaders {
  accountIds: string[];

  constructor(accountIds: string[] = [], headers?: string | {
    [name: string]: string | string[];
  }) {
    super(headers);
    this.accountIds = accountIds;
  }
}
